import type { DirectionKey } from '@/types'

/**
 * The dataset uses `outbound`/`inbound`; the UI prints `Departer`/`Return`.
 *
 * Mapped in exactly one place so the wording can change without touching data
 * code. Note the spelling is `Departer`, not `Departure` — that is what the
 * reference app shows (`docs/home_detail_stop_detail_passing_route.jpg`), and
 * matching it keeps the two apps legible side by side.
 */
const DIRECTION_LABELS: Record<DirectionKey, string> = {
  outbound: 'Departer',
  inbound: 'Return',
}

export function directionLabel(direction: DirectionKey): string {
  return DIRECTION_LABELS[direction]
}
